import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faPiggyBank,
  faUserCheck,
  faCalendarDays,
  faCheckCircle,
  faUtensils,
  faCarrot,
  faMobileScreen,
  faCloudMoon,
  faHandHoldingHeart,
  faTree,
  faStar,
  faSeedling,
  faDumbbell,
  faGift,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHandsPraying,
  faHospitalUser,
  faMoneyBillWave,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faCameraRetro,
  faHourglassEnd,
  faShoppingBasket,
  faFaceGrinHearts,
  faCalendarPlus,
  faDog,
  faCashRegister,
  faRulerCombined,
  faClipboardList,
  faGamepad,
  faTrash,
  faUsers,
  faBookOpen,
  faReceipt,
  faHeartCircleCheck,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faSyringe,
  faCar,
  faLeaf,
  faListCheck,
  faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
    { to: "/routine-diet-list", icon: faCarrot, label: "DietRoutine", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/exercise-list", icon: faDumbbell, label: "Exercise", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-teal-600", textColor: "text-white" },
    
    // { to: "/gym-list", icon: faDumbbell, label: "Gym", bgColor: "bg-teal-600", textColor: "text-white" },
    // { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },
    // { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-teal-600", textColor: "text-white" },
    // { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
    // { to: "/yoga-list", icon: faHeartPulse, label: "Yoga", bgColor: "bg-teal-600", textColor: "text-white" },
];


const AgriLinkHealthHome = () => {
    const navigate = useNavigate();

    return (
        <MainLayout>
            <div className="flex flex-col items-center py-4 px-4 bg-black border border-pink-400 h-auto mt-12 rounded-lg">
                <p className="text-lg lg:text-xl mb-2 text-yellow-200">My Health & Wellness</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-4 lg:grid-cols-8 gap-6">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AgriLinkHealthHome;
